import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../components/layout/ClientLayout";
import { useLocation, Link } from "react-router-dom";

const BetfairTopNav = () => {
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  useEffect(() => {
    var pathname = location.pathname;
    if (pathname != null && pathname != undefined) {
      setActiveTab(pathname);
    }
  }, []);
  return (
    <div className="scrollmenu">
      <style>{`
    .btn-black {
      background-color: #000000 !important;
      border-color: #000000 !important;
      color:white !important;
      font-weight:bold;
  `}</style>
      <Link
        to="/betfair-studio"
        style={{
          fontSize: ".875rem",
          lineHeight: "1.5",
          fontWeight: "bold",
          marginLeft: "0px"
        }}
        className="tablink btn-sm btn btn-primary"
      >
        <b>Lobby</b>
      </Link>

      <Link
        to="/betfair-hold"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-hold"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Hold'em
      </Link>

      <Link
        to="/betfair-turbo-hold"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-turbo-hold"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Turbo Hold'em
      </Link>

      <Link
        to="/betfair-blackjack"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-blackjack"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        BlackJack
      </Link>

      <Link
        to="/betfair-turbo-blackjack"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-turbo-blackjack"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Turbo BlackJack
      </Link>

      <Link
        to="/betfair-baccarat"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-baccarat"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Baccarat
      </Link>

      <Link
        to="/betfair-turbo-baccarat"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-turbo-baccarat"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Turbo Baccarat
      </Link>
      <Link
        to="/betfair-hilo"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-hilo"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Hi Lo
      </Link>
      <Link
        to="/betfair-turbo-hilo"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-turbo-hilo"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Turbo HiLo
      </Link>
      <Link
        to="/betfair-omaha"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-omaha"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Omaha Hi
      </Link>
      <Link
        to="/betfair-derby"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-derby"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Derby Race
      </Link>

      <Link
        to="/betfair-turbo-derby"
        style={{ marginLeft: "4px", fontSize: ".875rem", lineHeight: "1.5" }}
        className={
          activeTab === "/betfair-turbo-derby"
            ? "tablink btn-sm btn btn-black active"
            : "tablink btn-sm btn btn-primary"
        }
      >
        Derby Race Turbo
      </Link>
    </div>
  );
};

export default BetfairTopNav;
